import { StaticSymbolResolver } from "@angular/compiler";

export class RoutesConfig {

  static general = {
    notFound: 'not-found',
    notValidPage: 'not-valid-page',
    accessDeniedPage: 'access-denied',
  };
  
  static pages = {
    calendar: 'calendar',
    findSpace: 'find-a-space',
    meetings: 'meetings',
    bookings: 'bookings',
    serviceOrders: 'service-orders',
    teamRequest:'team-request',
    reservationWizard: 'reservation-wizard',
    preferences: 'preferences',
    preferenceViews: 'views',
    preferenceLanguages: 'languages',
      preferenceMenu: 'menu',
      catering: 'catering'
  };

  static RWRoutes = {
    details: 'reservation-details',
    selection: 'space-selection',
  }
}
